import { INotificationAction } from '../../typings';
import { CTA } from './typings';

export const ctaThemeMapper: Record<NonNullable<CTA['bg_theme']>, INotificationAction['theme']> = {
  dark: 'primary',
  lite: 'secondary',
};
